var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobGraverShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9faff;\n      }\n\n      .cls-2 {\n        fill: #6bff3b;\n      }\n\n      .cls-3 {\n        fill: #fff145;\n      }\n\n      .cls-4 {\n        fill: #b1e1e5;\n      }\n\n      .cls-5 {\n        fill: aqua;\n      }\n\n      .cls-6 {\n        fill: #c9ecf2;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "618.11 403.84 583.1 409.09 510.23 409.09 510.23 347.07 618.11 363.28 618.11 403.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "629.29 337.9 580.05 347.13 428.25 266.1 456.97 238.4 686.73 186.09 629.29 337.9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "428.25 266.1 367.73 363.54 39.44 414.65 558.31 416.27 629.29 337.9 428.25 266.1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "553 442.77 98.01 435.27 39.44 414.65 555.99 416.63 553 442.77"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "635.04 520.55 305.43 494.35 285.86 479.29 629.35 503.59 635.04 520.55"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "430.31 469.52 166.12 458.96 166.12 451.13 430.31 440.57 430.31 469.52"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "389.27 370.72 114.38 370.72 203.61 294.82 428.25 266.1 389.27 370.72"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "190.28 333.8 8.73 351.23 97.96 286.61 215.92 259.94 190.28 333.8"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "629.87 503.59 286.34 479.79 255.09 416.33 557.92 416.63 629.87 503.59"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "428.25 266.1 312.34 363.54 39.5 414.83 8.73 351.23 190.28 333.8 428.25 266.1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "39.5 414.83 215.92 382 428.25 266.1 629.29 337.9 254.9 402.52 39.5 414.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobGraverShip);
export default __webpack_public_path__ + "static/media/mob-graver-ship.9dd70f01e22d7f9356986a4a9148d7b7.svg";
export { ForwardRef as ReactComponent };